export enum Profession {
  DOCTOR = 'DOCTOR',
  RESIDENT = 'RESIDENT',
  NON_DOCTOR = 'NON_DOCTOR',
}
